import { IVeriLiteEvent, VeriLiteEventAction, VeriLiteWarningEvent } from '../../../../../Types';
import { IAuthenticatedAppData } from '../../../../../AuthenticatedApp/AuthenticatedApp';
import * as React from 'react';
import { ArvatoRenewCertEventContent } from '../Components';


export function ArvatoRenewCertEvent(locationName: string, updateCallback: (location: string, expiry:string) => void, applicationData: IAuthenticatedAppData) {
    var arvatoRenewCertEventContentRef = React.createRef<ArvatoRenewCertEventContent>();

    return new VeriLiteWarningEvent(
        <ArvatoRenewCertEventContent ref={arvatoRenewCertEventContentRef} locationName={locationName} updateCallback={updateCallback} applicationData={applicationData} />,
        applicationData.resources.ConfirmCertRenewal_Title,
        [
            new VeriLiteEventAction(
                applicationData.resources.Yes,
                "primary",
                () => {
                    arvatoRenewCertEventContentRef.current?.next();
                }
            ), new VeriLiteEventAction(
                applicationData.resources.No,
                "danger",
                (currentEvent: IVeriLiteEvent, closeModalCallback: (actionCallback?: () => void) => void) => {
                    closeModalCallback();
                }
            )
        ]
    );
}